import './index.css';
var SnackbarLayout;
(function (SnackbarLayout) {
    SnackbarLayout["Horizontal"] = "horizontal";
    SnackbarLayout["Vertical"] = "vertical";
})(SnackbarLayout || (SnackbarLayout = {}));
var SnackbarTransitionName;
(function (SnackbarTransitionName) {
    SnackbarTransitionName["Show"] = "show";
    SnackbarTransitionName["Hide"] = "hide";
    SnackbarTransitionName["Autohide"] = "autohide";
    SnackbarTransitionName["Replace"] = "replace";
    SnackbarTransitionName["RemoveImmediately"] = "removeImmediately";
})(SnackbarTransitionName || (SnackbarTransitionName = {}));

export { SnackbarLayout, SnackbarTransitionName };
//# sourceMappingURL=types.js.map
